"use client";

import { useTranslations } from "next-intl";

const NAMESPACE = "new-mjf-multi-jet-fusion";

const SIZE_COLS = [
	{ key: "Under30", labelKey: "prototypingTolerancesColUnder30" },
	{ key: "30to50", labelKey: "prototypingTolerancesCol30to50" },
	{ key: "50to80", labelKey: "prototypingTolerancesCol50to80" },
	{ key: "Over80", labelKey: "prototypingTolerancesColOver80" },
] as const;

const ROWS = [
	{
		materialKey: "prototypingTolerancesRow1Material",
		cells: [
			"prototypingTolerancesRow1Under30",
			"prototypingTolerancesRow1Col30to50",
			"prototypingTolerancesRow1Col50to80",
			"prototypingTolerancesRow1ColOver80",
		],
	},
	{
		materialKey: "prototypingTolerancesRow2Material",
		cells: [
			"prototypingTolerancesRow2Under30",
			"prototypingTolerancesRow2Col30to50",
			"prototypingTolerancesRow2Col50to80",
			"prototypingTolerancesRow2ColOver80",
		],
	},
] as const;

export default function MjfPrototypingTolerances() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-[#ffffff] py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<h2 className="mb-3 text-center text-2xl font-bold leading-tight text-black sm:mb-4 sm:text-[30px] md:text-4xl">
					{t("prototypingTolerancesTitle")}
				</h2>
				<p className="mx-auto mb-6 text-center text-sm leading-relaxed text-black sm:mb-8 md:mb-10 md:text-base lg:mb-12">
					{t("prototypingTolerancesDesc")}
				</p>

				<div className="overflow-x-auto border border-[#cfd9a8] bg-[#fafcef]">
					<table className="w-full min-w-[760px] border-collapse text-left">
						<thead>
							<tr className="bg-themePrimary400 text-white">
								<th className="border-r border-[#d5d9cc] px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base">
									{t("prototypingTolerancesColMaterial")}
								</th>
								{SIZE_COLS.map((col, idx) => (
									<th
										key={col.key}
										className={`px-4 py-4 text-sm font-semibold sm:px-6 sm:py-5 md:text-base${
											idx < SIZE_COLS.length - 1 ? "border-r border-[#d5d9cc]" : ""
										}`}
									>
										{t(col.labelKey)}
									</th>
								))}
							</tr>
						</thead>
						<tbody>
							{ROWS.map((row) => (
								<tr key={row.materialKey} className="border-t border-[#d5d9cc]">
									<th
										scope="row"
										className="border-r border-[#d5d9cc] px-4 py-4 align-top text-sm font-bold text-black sm:px-6 sm:py-5 md:text-base"
									>
										{t(row.materialKey)}
									</th>
									{row.cells.map((cellKey, idx) => (
										<td
											key={cellKey}
											className={`px-4 py-4 align-top text-sm leading-relaxed text-black sm:px-6 sm:py-5 md:text-base${
												idx < row.cells.length - 1 ? "border-r border-[#d5d9cc]" : ""
											}`}
										>
											{t(cellKey)}
										</td>
									))}
								</tr>
							))}
						</tbody>
					</table>
				</div>

				<p className="mt-5 text-sm leading-relaxed text-black sm:mt-6 md:text-base">
					<span className="font-bold">{t("prototypingTolerancesNoteLabel")}</span>
					{t("prototypingTolerancesNoteText")}
				</p>
			</div>
		</section>
	);
}
